<template>
  <v-container fluid>
    <v-layout row>
      <v-flex xs12
              sm6
              offset-sm3>
        <v-card>
          <v-card-text>
            <v-container>
              <form @submit.prevent="signUp">
                <v-layout row>
                  <v-flex>
                    <v-alert type="error"
                             dismissible
                             v-model="alert">
                      {{ error }}
                    </v-alert>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field name="email"
                                  label="eMail"
                                  id="email"
                                  v-model="email"
                                  type="email"
                                  :rules="emailRules"
                                  required
                                  class="input-group"></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field name="password"
                                  label="Password"
                                  id="password"
                                  type="password"
                                  v-model="password"
                                  required></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field name="confirmPassword"
                                  label="Confirm Password"
                                  id="confirmPassword"
                                  v-model="passwordConfirm"
                                  type="password"
                                  :rules="[comparePasswords]"></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex xs12>
                    <v-text-field name="company"
                                  label="Company"
                                  id="company"
                                  v-model="company"
                                  type="company"
                                  required
                                  :rules="companyRules"
                                  class="input-group"></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex xs12
                          sm6
                          md4>
                    <v-text-field name="username"
                                  label="First name"
                                  id="username"
                                  v-model="username"
                                  type="username"
                                  required
                                  :rules="nameRules"
                                  class="input-group"></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex xs12
                          sm6
                          md4>
                    <v-text-field name="lastname"
                                  label="Last name"
                                  id="lastname"
                                  v-model="lastname"
                                  type="lastname"
                                  required
                                  :rules="nameRules"
                                  class="input-group"></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout>
                  <v-flex xs12>
                    <v-text-field name="mobile"
                                  label="Mobile (Optional: For Text Notifications)"
                                  id="Mobile"
                                  v-model="mobile"
                                  :rules="phoneRules"
                                  type="mobile"
                                  class="input-group"></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout>
                  <v-flex xs12>
                    <v-text-field name="ref"
                                  label="Referral Code"
                                  id="ref"
                                  v-model="ref"
                                  type="ref"
                                  :counter=6
                                  class="input-group"></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout>
                  <v-radio-group v-model="userType"
                                 row>
                    <v-radio label="Shipper"
                             value="shipper"></v-radio>
                    <v-radio label="Broker"
                             value="broker"></v-radio>
                  </v-radio-group>
                </v-layout>

                <v-layout row>
                  <v-flex xs12>
                    <v-btn type="submit">Sign up</v-btn>
                  </v-flex>
                </v-layout>
              </form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import firebase from 'firebase'
import db from './fireBaseInit'
export default {
  name: 'signUp',
  data: function () {
    return {
      email: '',
      password: '',
      passwordConfirm: '',
      error: '',
      alert: false,
      userType: 'shipper',
      company: '',
      username: '',
      lastname: '',
      userID: '',
      ref: '',
      mobile: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'],
      nameRules: [
        v => !!v || 'UserName is required'
      ],
      companyRules: [
        v => !!v || 'Company Name is required'
      ],
      phoneRules: [
        v => /^$|^(\+\d{1,4})?[\s-]?\(?(\d{3})\)?[\s-]?\d{3}[\s-]?\d{4}/.test(v) || 'Mobile number must be valid'
      ]
    }
  },

  methods: {
    signUp: function () {
      if (this.comparePasswords !== true) {
        return
      }
      let broker = true
      let shipper = true
      if (this.userType === 'shipper') {
        broker = false
      } else {
        shipper = false
      }
      firebase.auth().createUserWithEmailAndPassword(this.email, this.password).then(
        (user) => {
          alert('Your account has been created, a conformation email has been sent to your email address.')
          user.sendEmailVerification()
          user.updateProfile({
            displayName: this.username
          })
          this.userID = user.uid
          db.collection('users').doc(user.uid).set({
            email: this.email,
            company: this.company,
            username: this.username,
            lastname: this.lastname,
            type: this.userType,
            active: true,
            isBroker: broker,
            isShipper: shipper,
            mobile: this.mobile,
            sendSMS: true,
            referral: this.ref
          })
          // update shipper
          if (broker && this.ref) {
            this.getShipper(this.ref, this.userID)
          }
          this.$router.replace('/')
        },
        (err) => {
          alert('Oops. ' + err.message)
        }
      )
    },
    getShipper: function (senderRef, brokerID) {
      db.collection('mail').where('senderRef', '==', senderRef).get().then((snap) => {
        snap.forEach(doc => {
          this.updateShipper(doc.data().senderID, brokerID)
        })
      })
    },
    updateShipper: function (shipperID, brokerID) {
      console.log(shipperID)
      db.collection('users').doc(shipperID).get().then((snap) => {
        let brokerList = {}
        brokerList[brokerID] = true
        for (var key in snap.data().brokers) {
          brokerList[key] = true
        }
        var brokerObj = { brokers: brokerList }
        console.log(brokerObj)
        db.collection('users').doc(shipperID).update(brokerObj)
      })
    }
  },
  computed: {
    comparePasswords () {
      return this.password === this.passwordConfirm ? true : 'Passwords don\'t match'
    }
  },
  watch: {
    user (value) {
      if (value !== null && value !== undefined) {
        this.$router.push('/')
      }
    },
    error (value) {
      if (value) {
        this.alert = true
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/SignUp.vue